import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isAssignmentModalOpen: false,
	assignmentFormData: {}
};

const assignmentsSlice = createSlice({
	name: "assignments",
	initialState,
	reducers: {
		toggleAssignmentModal: (state, action) => {
			const isAssignmentModalOpen = action.payload;
			state.isAssignmentModalOpen = isAssignmentModalOpen;
			if (!isAssignmentModalOpen) {
				state.assignmentFormData = {}
			}
		},
		getAssignmentFormData: (state, action) => {
			state.assignmentFormData = action.payload;
		}
	},
});

export const { toggleAssignmentModal, getAssignmentFormData } = assignmentsSlice.actions;
export default assignmentsSlice.reducer;
